import React, { FC, useContext, useState } from 'react';
import classes from './LicenseAboutExpireModal.module.scss';
import { createPortal } from 'react-dom';
import { declensionOfDays } from './utils';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { LicenseContext } from '../../../context/LisenceContext/LicenseContext';
import { MailIcon, ModalCloseIcon, PhoneIcon } from '../../../assets/icons';
import Typography, { TypographyVariant } from '../../Typography/Typography';
import { adminRoutesURLs, buildAdminPath } from '../../../constants/routes';
import modalBase from '../../ModalBase/ModalBase.module.scss';

export const LicenseAboutExpireModal: FC = () => {
  const [isUnmounting, setIsUnmounting] = useState(false);
  const { daysUntilLicenseExpires, isLicenseAboutExpiredModal, resetLicenseAboutExpiredModal } =
    useContext(LicenseContext);

  const onCloseClick = () => {
    setIsUnmounting(true);
    const id = setTimeout(() => {
      resetLicenseAboutExpiredModal();
      clearTimeout(id);
    }, 300);
  };

  return (
    <>
      {isLicenseAboutExpiredModal &&
        typeof daysUntilLicenseExpires === 'number' &&
        daysUntilLicenseExpires >= 0 &&
        daysUntilLicenseExpires <= 30 &&
        createPortal(
          <div
            className={classNames(modalBase.modal, modalBase.active, classes.licenseAboutExpireModalContainer, {
              [classes.unmount]: isUnmounting
            })}>
            <div className={modalBase.container}>
              <ModalCloseIcon className={classes.closeButton} onClick={onCloseClick} />
              <div className={classes.titleWrapper}>
              <div className={classes.titleContainer}>
                <Typography variant={TypographyVariant.h2_semibold}>
                  Срок действия вашей лицензии истекает, осталось:
                </Typography>
                <div className={classes.daysContainer}>
                  {daysUntilLicenseExpires
                    .toString()
                    .split('')
                    .map((char, index) => (
                      <Typography
                        key={char + index}
                        variant={TypographyVariant.h1_semibold}
                        className={classes.daysNumber}>
                        {char}
                      </Typography>
                    ))}
                </div>
                <Typography variant={TypographyVariant.h2_semibold}>
                  {declensionOfDays(daysUntilLicenseExpires)}
                </Typography>
              </div>
              <Typography
                variant={TypographyVariant.text_secondary_regular}
                className={classes.subTitle}>
                В случае непродления лицензии все модули программного обеспечения станут недоступны
              </Typography>
            </div>

            <Link
              to={buildAdminPath(adminRoutesURLs.userArea)}
              onClick={onCloseClick}
              className={classes.link}>
              <Typography
                variant={TypographyVariant.h2_bold}
                tagName="span"
                className={classes.linkText}>
                Добавить новый ключ
              </Typography>
            </Link>

            <div className={classes.contactsContainer}>
              <div className={classes.contact}>
                <PhoneIcon className={classes.phoneIcon} />
                <Typography variant={TypographyVariant.h4_regular}>+375(29) 198 00 04</Typography>
              </div>

              <div className={classes.contact}>
                <MailIcon className={classes.mailIcon} />
                <Typography variant={TypographyVariant.h4_regular}>info@high-tech.by</Typography>
              </div>
            </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
